var map = {
	"./3a.jpg": 31,
	"./France.jpg": 32,
	"./OMAN.jpg": 33,
	"./UAE.jpg": 34,
	"./casa.jpg": 35,
	"./iran.jpg": 36,
	"./kor.jpg": 37,
	"./kuwait.jpg": 38,
	"./montreal.jpg": 39,
	"./pan.jpg": 40,
	"./singapore.jpg": 41,
	"./sweden.jpg": 42,
	"./vancouver.jpg": 43
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;